<template>
  <section class="hero is-fullheight">
    <div class="hero-head">
      <app-nav
        :full-name="userFullName"
        :navbar-theme="'is-light'" />
    </div>
    <div class="hero-body">
      <div class="container has-text-centered">
        <h1 class="title">
          <form @submit.prevent="search">
            <b-field>
              <b-input
                ref="articleIdInput"
                v-model="articleId"
                placeholder="Scan or type here ..."
                size="is-large"
                type="search"
                icon="barcode" />
            </b-field>
          </form>
        </h1>
      </div>
    </div>
  </section>
</template>

<script>
import AppNav from './AppNav'
import { checkLogin, getUser } from '../utils/auth'
import { searchArticle } from '../utils/api'

export default {
  name: 'scan',
  components: {
    AppNav
  },
  data() {
    return {
      articleId: '',
      userFullName: ''
    }
  },
  mounted() {
    let self = this
    checkLogin().then(function(loggedIn) {
      if (loggedIn) {
        self.userFullName = JSON.parse(getUser()).fullName
        self.$refs.articleIdInput.focus()
      } else {
        self.$router.push('/login')
      }
    })
  },
  methods: {
    search() {
      let self = this
      let param = { articleId: self.articleId }
      searchArticle(param)
        .then(function(resp) {
          self.$toast.open({
            message: 'Article was found.',
            duration: 2000,
            position: 'is-top',
            type: 'is-success'
          })
          self.$router.push(`/articles/${self.articleId}`)
        })
        .catch(function() {
          self.$toast.open({
            message: 'Article was not found.',
            duration: 3000,
            position: 'is-top',
            type: 'is-danger'
          })
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.subtitle-below-input {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Scan.vue